import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Spinner } from "@/components/ui/spinner";

/**
 * Layer 1: requires Supabase session. Renders nested routes via Outlet.
 */
export function AuthGuard() {
  const { status } = useAuth();

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Spinner className="text-muted-foreground" />
        <span className="sr-only">Loading</span>
      </div>
    );
  }

  if (status === "unauthenticated") {
    return <Navigate to="/signin" replace />;
  }

  return <Outlet />;
}
